var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "cargo-advance-select",
        _vm._b(
          {
            ref: "select",
            attrs: {
              "default-multiple-value": _vm.value,
              "automatic-dropdown": true
            },
            on: { parentCallBack: _vm.onParentCallBack }
          },
          "cargo-advance-select",
          _vm.params.selectProps,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }